import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { db } from '../../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export default function Thanks() {
  const location = useLocation();
  const [state, setState] = React.useState({});
  React.useEffect(() => {
    const pushData = async state => {
      setState(() => state);
      try {
        await addDoc(collection(db, 'contact-requests'), {
          ...state,
          createdAt: serverTimestamp(),
        });
      } catch (err) {
        console.error(err);
      }
    };

    pushData(location.state);
  }, [location.state]);

  return (
    <div className="my-12 flex flex-col items-center justify-center bg-white px-6">
      <div className="w-full max-w-md bg-white p-10 text-center">
        <h1 className="text-3xl font-bold text-gray-900">Grazie per averci contattato!</h1>

        <p className="mt-3 text-lg text-gray-600">
          {state?.firstName
            ? `Ciao ${state?.firstName}, abbiamo ricevuto la tua richiesta.`
            : 'La tua richiesta è stata inviata correttamente.'}
        </p>

        <Link
          to="/"
          className="mt-6 inline-block rounded-md bg-primary px-6 py-2 text-sm font-medium text-white hover:bg-primary/90"
        >
          Torna alla Home
        </Link>
      </div>
    </div>
  );
}
